import { render } from "./uk15.vue?vue&type=template&id=32353f3a"
import script from "./uk15.vue?vue&type=script&lang=js"
export * from "./uk15.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__